var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vdatetime-year-picker" }, [
    _c(
      "div",
      {
        ref: "yearList",
        staticClass: "vdatetime-year-picker__list vdatetime-year-picker__list"
      },
      _vm._l(_vm.years, function(year) {
        return _c(
          "div",
          {
            staticClass: "vdatetime-year-picker__item",
            class: { "vdatetime-year-picker__item--selected": year.selected },
            on: {
              click: function($event) {
                return _vm.select(year.number)
              }
            }
          },
          [_vm._v(_vm._s(year.number))]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61c75f28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c75f28","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/vue-datetime/DatetimeYearPicker.vue
// module id = null
// module chunks = 